module.exports = __webpack_public_path__ + "static/media/OPTIMA_B.fd288340.TTF";